import { usePlayground } from "@/components/Playground/playground-store";
import { ChatSettingsI } from "@/queries/playground/useUpdatePlaygroundSession";

export const usePlaygroundChatSettings = (variableKey?: string | null) => {
  let chat_settings: Partial<ChatSettingsI> | null = null;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let setChatSettings: (settings: Partial<ChatSettingsI>) => void = () => {};
  let isSessionModeChat = false;

  try {
    const playground = usePlayground();
    ({ chat_settings, setChatSettings, isSessionModeChat } = playground);
  } catch {
    // Outside PlaygroundProvider - use safe defaults
  }

  const chatSettingsVariableKeys = Object.values(chat_settings ?? {});
  const isChatSettingsVariableKey = chatSettingsVariableKeys.includes(variableKey ?? "");

  const getChatSettingsKeyByVariableKey = () => {
    switch (variableKey) {
      case chat_settings?.injection_variable:
        return "injection_variable";
      case chat_settings?.user_input_variable:
        return "user_input_variable";
      default:
        return variableKey;
    }
  };

  const getChatSettingsLabelByVariableKey = () => {
    switch (variableKey) {
      case chat_settings?.injection_variable:
        return "History Injection";
      case chat_settings?.user_input_variable:
        return "User Input";
      default:
        return variableKey;
    }
  };

  const updateChatSettings = (key?: string | null, value?: string | null) => {
    if (!key) {
      return;
    }
    setChatSettings({ ...chat_settings, [key]: value });
  };

  return {
    isChatMode: isSessionModeChat,
    chat_settings,
    chatSettingsVariableKeys,
    isChatSettingsVariableKey,
    getChatSettingsKeyByVariableKey,
    getChatSettingsLabelByVariableKey,
    updateChatSettings,
  };
};
